<span *ngIf="countdownLabel && show" [class]="'badge ' + (textOnly ? ('text-only ' + countdownClass) : countdownClass)">
  <ng-container *ngIf="!textOnly"><i class="ti ti-hourglass me-1"></i> </ng-container>{{ countdownLabel }}
</span>
